export function url(strings: any, ...values: any) {
  // Filter out any undefined or null values
  const queryString = values
    .map((value: any, i: any) => {
      if (value === undefined || value === null || value === "") {
        return "";
      }
      return `${strings[i]}${encodeURIComponent(value)}`;
    })
    .join("");
  if (queryString[0] === "&") {
    let newString = queryString.slice(1);
    return `${newString}`;
  }
  return `${queryString}`;
}

// import dayjs from 'dayjs'

export function getTraceName(spans: any[]) {
  const parentSpan = spans?.find((span: any) => span?.parentspanid === "");
  return parentSpan?.spanname || "No name";
}

export function getTotalDuration(spans: any[]) {
  const parentSpan = spans?.find((span: any) => span?.parentspanid === "");

  return parentSpan?.duration;
}

export function getTickLabels(spans: any[]) {
  // const parentSpan = spans.find((span: any) => span?.ParentSpanID === '' && span?.Operation!=="Egress")
  const parentSpan = spans[0];
  const labels = [];
  if (parentSpan) {
    const numTicks = 5;

    const viewingDuration = parentSpan?.Duration;
    for (let i = 0; i < numTicks; i++) {
      const durationAtTick = (0 || 0) + (i / (numTicks - 1)) * viewingDuration;
      const portion = i / (numTicks - 1);
      labels.push({ label: formatDuration(durationAtTick), portion });
    }
  }
  return labels;
}

export const formatDuration = (duration: number) => {
  const ms = duration / 1000000;
  return ms > 1 ? `${ms.toFixed(3)} ms` : `${duration.toFixed(3)} μs`;
};
